import { createContext, useContext, useRef, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
 
const ResponseContext = createContext();
 
export const ResponseProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const timeouts = useRef({});
 
    const addMessage = (data, displayTime = 5000) => {
        const id = uuidv4();
        const msg = { id, ...data, displayTime };
 
        setMessages((prev) => [...prev, msg]);
 
        timeouts.current[id] = setTimeout(() => {
            setMessages((prev) => prev.filter((m) => m.id !== id));
            delete timeouts.current[id];
        }, displayTime);
    };
 
    useEffect(() => {
        return () => Object.values(timeouts.current).forEach(clearTimeout);
    }, []);
 
    return (
        <ResponseContext.Provider value={{ addMessage }}>
            {children}
            <div className={`response-message-wrapper ${messages.length > 0 ? "visible" : ""}`}>
                {messages.map((msg) => (
                    <Message key={msg.id} messageData={msg} />
                ))}
            </div>
        </ResponseContext.Provider>
    );
};
 
const Message = ({
    messageData
}) => {
    const successful = messageData?.error === undefined || messageData.error === null;
    const dataToDisplay = successful
        ? messageData?.data ? getDataToDisplay(messageData.data) : null
        : messageData?.error ? getDataToDisplay(messageData.error) : null;
    const messageTypeClass = messageData?.type 
        ? `response-message--${messageData.type}`
        : successful
            ? "response-message--notification"
            : "response-message--warning";
 
    return dataToDisplay ? (
        <div className={`response-message ${messageTypeClass}`}>
            {dataToDisplay}
        </div>
    ) : null
}

const getDataToDisplay = (data) => {
    const dataToDisplay = Array.isArray(data)
        ? (
            <ul>
                {data.map((item, index) => <li key={index} dangerouslySetInnerHTML={{__html: item}} />)}
            </ul>
        ) : <p dangerouslySetInnerHTML={{__html: data}} />;
 
    return dataToDisplay;
}
 
export const useResponseMessages = () => useContext(ResponseContext);
 